const bad_food = `Subject: Problem with the Chicken Nuggets I Bought
Dear Store Manager,
I want to tell you about something bad that happened when I bought chicken nuggets from your store today.
When I cooked them for dinner, they didn't smell right and felt weird. 
When I looked closer, some parts were still not cooked even though I followed the instructions.
This made me really sad and worried about getting sick from eating not cooked food. 
I usually trust your store, but now I'm not so sure about how safe your food is.
Please look into this and fix it so it doesn't happen again.
I would like my money back for the bad chicken nuggets.
You should also check how you make the food to make sure this doesn't happen again.
I hope you can do something about this and make me trust your store again.
Sincerely,`;
export default bad_food;
